import { Shifts } from "../types";

export const validateShift = (auditDate: Date, shift: Shifts) => {
  const hours = auditDate.getHours();

  switch (shift) {
    case Shifts.first:
      if (hours >= 7 && hours < 15) {
        return true;
      }
      break;
    case Shifts.second:
      if (hours >= 15 && hours < 23) {
        return true;
      }
      break;
    case Shifts.third:
      if ((hours >= 0 && hours < 7) || hours == 23) {
        return true;
      }
      break;
  }

  return false;
};
